import React from 'react';

export function EmptyList() {
  return (
    <div className="column w-full justify-center p-24">
      <h2 className="typography-display-4 text-center">No items found</h2>
    </div>
  );
}
